import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-incident-children',
  templateUrl: './incident-children.component.html',
  styleUrls: ['./incident-children.component.css']
})
export class IncidentChildrenComponent implements OnInit {

  childrenData: any[] = [];
  columns: any[] = [
    { name: "instanceId", displayName: "Instance Id" },
    { name: "IncidentId", displayName: "Incident Id" },
    { name: "medicine", displayName: "Medicine" }
  ];

  totalCount: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.childrenData = this.data.childrenData;
      this.totalCount = this.childrenData.length;
    }, 200);
  }

}
